import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=9a0fac12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a0fac12"]])

export default __exports__